<template>
  <v-ons-page>

    <div class="header">
      <img src="../../assets/lasmeru-logo-bold.png" width="250" height="100" style="margin-top: 50px; margin-bottom: 30px;">
    </div>

    <v-ons-list-title>アカウントの作成</v-ons-list-title>
    <div>
      <v-ons-list>
        <v-ons-list-item modifier="nodivider">
          <div class="center">
            サービス利用規約をご覧いただき<br>
            同意して先に進んでください。
          </div>
        </v-ons-list-item>
        <v-ons-list-item modifier="nodivider">
          <!-- <textarea class="textarea" style="margin: auto" rows="5" cols="40" v-model="termsContent"></textarea> -->
          <v-ons-button style="margin: auto" @click="dialogVisible = true">サービス利用規約</v-ons-button>
        </v-ons-list-item>
        <v-ons-list-item modifier="nodivider">
          <label class="left">
            <v-ons-checkbox
              input-id="chk_terms"
              :value="true"
              v-model="termsAndConditions"
            >
            </v-ons-checkbox>
          </label>
          <label class="center" for="chk_terms">
            サービス利用規約に同意します。
          </label>
        </v-ons-list-item>
        <v-ons-list-item modifier="nodivider">
          <v-ons-button style="margin: auto" @click="privacyPolicyOn = true">個人情報保護方針</v-ons-button>
        </v-ons-list-item>
        <v-ons-list-item modifier="nodivider">
          <label class="left">
            <v-ons-checkbox
              input-id="chk_policy"
              :value="true"
              v-model="privacyPolicy"
            >
            </v-ons-checkbox>
          </label>
          <label class="center" for="chk_policy">
            個人情報保護方針に同意します。
          </label>
        </v-ons-list-item>
      </v-ons-list>
    </div>

    <div v-show="termsAndConditions && privacyPolicy">
      <v-ons-card>
        <div class="title">ユーザー登録を始めよう！</div>
        <div class="content">
          <v-ons-list-item modifier="nodivider">
            <v-ons-button :disabled="!termsAndConditions || !privacyPolicy" modifier="large" @click="goOauthAccount">ユーザー登録へ</v-ons-button>
          </v-ons-list-item>
        </div>
      </v-ons-card>
    </div>

    <v-ons-dialog cancelable :visible.sync="dialogVisible">
      <div class="dialogview2">
        <!-- <p style="font-size: 0.5rem" v-html="serviceTerms"></p> -->
        <service-terms></service-terms>
        <v-ons-button modifier="large" @click="dialogVisible = false">閉じる</v-ons-button>
      </div>
    </v-ons-dialog>

    <v-ons-dialog cancelable :visible.sync="privacyPolicyOn">
      <div class="dialogview2">
        <!-- <p style="font-size: 0.5rem" v-html="serviceTerms"></p> -->
        <privacy-policy></privacy-policy>
        <v-ons-button modifier="large" @click="privacyPolicyOn = false">閉じる</v-ons-button>
      </div>
    </v-ons-dialog>

  </v-ons-page>
</template>

<script>
// import firebase from 'firebase'
import common from '../../util/common'
import ServiceTerms from './ServiceTerms'
import PrivacyPolicy from './PrivacyPolicy'

export default {
  name: 'InitialStart',
  mixins: [common],
  components: {ServiceTerms, PrivacyPolicy},
  data () {
    return {
      termsAndConditions: false,
      privacyPolicy: false,
      dialogVisible: false,
      privacyPolicyOn: false
    }
  },

  created () {
  },

  computed: {
  },

  watch: {
  },

  methods: {
    goOauthAccount () {
      this.$store.commit('routerAnim/set', 'back')
      this.$router.push({name: 'SignUp'})
    }
    // createAnonymousAccount () {
    //   var self = this

    //   firebase.auth().signInAnonymously().then(e => {
    //     // ログイン成功
    //     console.log(e)
    //     self.$store.commit('routerAnim/set', 'back')
    //     self.$router.replace({path: '/'})
    //   }).catch((error) => {
    //     // エラーメッセージ
    //     var errorCode = error.code
    //     var errorMessage = error.message
    //     console.log('匿名認証エラー', errorCode, errorMessage)
    //   })
    // },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../../../src/assets/css/miley.css";
</style>



// WEBPACK FOOTER //
// src/components/AccountChildren/InitialStart.vue